import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Show employee")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Edit employee")
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Block employee")
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Unblock employee")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_uuid = _resolveComponent("uuid")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_toggle = _resolveComponent("q-toggle")!
  const _component_q_table = _resolveComponent("q-table")!

  return (_openBlock(), _createBlock(_component_q_table, {
    columns: _ctx.employeeColumns,
    rows: _ctx.employees,
    pagination: _ctx.pagination,
    "onUpdate:pagination": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pagination) = $event)),
    flat: "",
    "row-key": "id",
    class: "sticky-actions-column"
  }, {
    "body-cell-id": _withCtx((props) => [
      _createVNode(_component_q_td, { props: props }, {
        default: _withCtx(() => [
          _createVNode(_component_uuid, {
            id: props.value
          }, null, 8, ["id"])
        ]),
        _: 2
      }, 1032, ["props"])
    ]),
    "body-cell-roles": _withCtx((props) => [
      _createVNode(_component_q_td, null, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.row.roles, (role) => {
            return (_openBlock(), _createElementBlock("div", {
              key: role.key + '-' + props.row.id
            }, _toDisplayString(role.name), 1))
          }), 128))
        ]),
        _: 2
      }, 1024)
    ]),
    "body-cell-actions": _withCtx((props) => [
      _createVNode(_component_q_td, null, {
        default: _withCtx(() => [
          _createVNode(_component_q_btn, {
            color: "grey",
            dense: "",
            flat: "",
            icon: "pageview",
            round: "",
            onClick: ($event: any) => (_ctx.onShowEmployee(null, props.row))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_tooltip, null, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              })
            ]),
            _: 2
          }, 1032, ["onClick"]),
          _createVNode(_component_q_btn, {
            color: "grey",
            dense: "",
            flat: "",
            icon: "edit",
            round: "",
            onClick: ($event: any) => (_ctx.onEditEmployee(props.row))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_tooltip, null, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              })
            ]),
            _: 2
          }, 1032, ["onClick"]),
          (props.row.isActive)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                _createVNode(_component_q_toggle, {
                  modelValue: props.row.isActive,
                  "onUpdate:modelValue": ($event: any) => ((props.row.isActive) = $event),
                  "checked-icon": "check",
                  color: "green",
                  "unchecked-icon": "clear",
                  onClick: ($event: any) => (_ctx.onBlock(props.row))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_tooltip, null, {
                      default: _withCtx(() => [
                        _hoisted_4
                      ]),
                      _: 1
                    })
                  ]),
                  _: 2
                }, 1032, ["modelValue", "onUpdate:modelValue", "onClick"])
              ]))
            : _createCommentVNode("", true),
          (!props.row.isActive)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                _createVNode(_component_q_toggle, {
                  "unchecked-icon": "clear",
                  modelValue: props.row.isActive,
                  "onUpdate:modelValue": ($event: any) => ((props.row.isActive) = $event),
                  onClick: ($event: any) => (_ctx.onUnblock(props.row))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_tooltip, null, {
                      default: _withCtx(() => [
                        _hoisted_6
                      ]),
                      _: 1
                    })
                  ]),
                  _: 2
                }, 1032, ["modelValue", "onUpdate:modelValue", "onClick"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 2
      }, 1024)
    ]),
    _: 1
  }, 8, ["columns", "rows", "pagination"]))
}